<template>
  <div class="clause-item">
    <div class="header-cell">
        <span class="arrow-icon" @click="toggleClause" :class="{ 'rotated': clause?.is_open }">▼</span>
        <div class="title-wrapper" :class="{ 'have_notes': clause?.notes?.length > 0 }">
          <div v-if="!isEditingTitle" class="title-content" :class="{ 'editable': editable }">
            <span>{{ clause.short_title }}</span>
            <button 
              v-if="editable" 
              class="edit-icon-btn" 
              @click.stop="startEditingTitle($event)"
              title="עריכת כותרת"
            >
              <i class="fas fa-edit"></i>
            </button>
          </div>
          <div v-else class="title-edit">
            <textarea 
              v-model="editedTitle" 
              ref="titleTextarea"
              class="title-textarea"
             
            ></textarea>
            <button @click="saveTitle" class="save-btn">שמירה</button>
            <button @click="cancelEditTitle" class="cancel-btn">ביטול</button>
          </div>
        </div>
        <div v-if="clause?.is_open" class="clause-content">
          {{ clause.content }}
        </div>
    </div>

    <div class="clauses-container">
      <div class="flex-row">
        <div 
          v-for="user in selectedEnts" 
          :key="user.id + '-' + clause.id" 
          class="flex-cell"
          :style="`--clause_width: calc(var(--ent_width_${user.id}) - var(--ent_gap));`"
          :class="{ 'selected': selectedNoteId && clause.notes.find(n => n.id === selectedNoteId && n.ents.find(e => e.id === user.id)) }"
          @click="mode === 'edit' && toggleNote(user)"
          >
          <div class="answer_container">
            <div 
              class="answer_status" 
              :class="getStatusClass(user)"
            >
              <i class="fas fa-check" v-if="getStatusClass(user) === 'accepted'"></i>
              <i class="fas fa-times" v-if="getStatusClass(user) === 'rejected'"></i>
              <i class="fas fa-window-minimize" v-if="getStatusClass(user) === 'pending'"></i>
            </div>
            <div class="answer_text">
              <div v-text="getUserClauseNote(user)" v-show="clause?.is_open"></div>
            </div>
            
          </div>
          <div class="add_note" v-if="mode === 'edit'">
            <div v-if="!selectedNoteId || !clause.notes.find(n => n.id === selectedNoteId && n.ents.find(e => e.id === user.id))" class="add">
              <i class="fas fa-plus"></i>
            </div>
            <div v-else class="times">
              <!-- <i class="fas fa-window-minimize"></i> -->
              <i class="fas fa-times"></i>

            </div>
            <!-- <div class="icon">
              <i class="fas fa-window-minimize"></i>
            </div> -->
          </div>
        </div>

      </div>
      <div class="notes_container" v-show="clause?.is_open">
        <userNote 
          v-for="note in clause.notes" 
          :key="note.id"
          :note="note" 
          :selected="selectedNoteId === note.id"
          :mode="mode"
          @removeNote="removeNote" 
          @addNote="addNote()" 
          @removeEnt="removeEnt" 
          @editSaveNote="editSaveNote" 
        />
      </div>
      <!-- add the notes comp here -->
    </div>
  </div>
</template>

<script>
import userNote from './userNote.vue';
export default {
  name: 'ClauseItem',
  components: {
    userNote
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    clause: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    selectedEnts: {
      type: Array,
      default: () => []
    },
    entsWidth: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: 'edit',
      validator: (value) => ['edit', 'watch'].includes(value)
    }
  },
  emits: ['toggle', 'updateClauseTitle'],
  data() {
    return {
      notes: [],
      selectedNoteId: null,
      isEditingTitle: false,
      editedTitle: ''
    };
  },
  methods: {
    toggleClause() {
      this.clause.is_open = !this.clause.is_open;
      if(!this.clause?.is_open) this.selectedNoteId = null;
    },
    rewardClauses(user) {
      if (!user || !user.contract || !user.contract.types) {
        return [];
      }
      
      // Cache the result using a WeakMap if this method is called frequently
      const allClauses = [];
      const stack = [];
      
      // Add all parts from all types to the stack
      for (const type of user.contract.types) {
        if (type.parts && type.parts.length > 0) {
          stack.push(...type.parts);
        }
      }
      
      while (stack.length > 0) {
        const part = stack.pop();
        
        if (part.clauses && part.clauses.length > 0) {
          allClauses.push(...part.clauses);
        }
        
        if (part.parts && part.parts.length > 0) {
          stack.push(...part.parts);
        }
      }
      
      return allClauses;
    },
    getClauseForUser(user, clauseId) {
      const allClauses = this.rewardClauses(user);
      return allClauses.find(clause => clause.clause_id === clauseId) || null;
    },
    getStatusClass(user) {
      const userClause = this.getClauseForUser(user, this.clause.id);
      if (!userClause) return 'pending';
      
      return userClause.approve === true ? 'accepted' : 
             userClause.approve === false ? 'rejected' : 
             'pending';
    },
    getUserClauseNote(user) {
      const userClause = this.getClauseForUser(user, this.clause.id);
      return userClause ? (userClause.note) : '';
    },
    toggleNote(user) {
      if(!this.clause?.is_open) this.clause.is_open = true;
      if (this.selectedNoteId) {
        const note = this.clause.notes.find(note => note.id === this.selectedNoteId);
        if (note) {
          const entIndex = note.ents.findIndex(ent => ent.id === user.id);
          if (entIndex === -1) {
            note.ents.push(user);
          } else {
            note.ents.splice(entIndex, 1);
          }
        }
      } else {
        this.addNote([user]);
        this.selectedNoteId = this.clause.notes[0].id;
      }
    },
    addNote(users=[]) {
      if(!this.clause?.notes) this.clause.notes = [];
      this.clause.notes.unshift({
        id: Math.random().toString(36).substring(2, 15),
        text: '',
        ents: users,
        clause_id: this.clause.id
      });
    },
    editSaveNote(note_id) {
      if (this.selectedNoteId) {
        this.selectedNoteId = null; 
      } else {
        this.selectedNoteId = note_id;
      }
    },
    removeEnt(ent_id, note_id) {
      const note = this.clause.notes.find(note => note.id === note_id);
      if (note) {
        note.ents = note.ents.filter(e => e.id !== ent_id);
      }
      if (this.selectedNoteId != note_id) this.selectedNoteId = note_id;
    },
    removeNote(note_id) {
      this.clause.notes = this.clause.notes.filter(note => note.id !== note_id);
    },
    startEditingTitle(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.isEditingTitle = true;
      this.editedTitle = this.clause.short_title;
      this.$nextTick(() => {
        if (this.$refs.titleTextarea) {
          this.$refs.titleTextarea.focus();
        }
      });
    },
    saveTitle() {
      if (this.editedTitle.trim()) {
        // כאן תוכל להוסיף פונקציה שתישלח לשרת
        this.updateClauseTitle(this.clause.id, this.editedTitle.trim());
        this.clause.short_title = this.editedTitle.trim();
        this.isEditingTitle = false;
      }
    },
    cancelEditTitle() {
      this.isEditingTitle = false;
      this.editedTitle = '';
    },
    updateClauseTitle(clauseId, newTitle) {
      this.api({ action: 'contracts/update_clause', data: {token: this.$store.token, clause_id: clauseId, short_title: newTitle }}, (data)=>{
        if (data.data) {
          this.toast('פרטים נשלחו בהצלחה' , 'success');
        } else {
          this.toast('תקלה בשליחת הפרטים נסו מאוחר יותר' , 'error');
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.clause-item {  gap: var(--gap);  border-bottom: 1px solid #E7F0F3; padding-block: 25px;
  display: flex;
  // display: contents;

  .header-cell { z-index: 2; background: #fff; min-height: 120px; padding-left: var(--gap); font-weight: 700; width: var(--title_width); min-width: var(--title_width); position: sticky; right: 0; background: #fff; cursor: pointer;
    &:after { content: ''; position: absolute; top: 0; bottom: 0; left: 0; display: block; width: 1px; height: 100%; background: #CCDAE2; }
    .arrow-icon { position: absolute; top: 50%; left: 0; font-size: 12px; transition: transform 0.3s ease; transform: translate(-50%, -50%) rotate(-180deg); transform-origin: center; z-index: 1; background: #D9D9D9; width: 22px; height: 22px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
      &.rotated { transform: translate(-50%, -50%) rotate(0deg); }
    }

    .title-wrapper { display: flex; align-items: center; gap: 8px; 
      &::before { content: ''; /* position: relative; right: 10px; */ background: #B2C8D3; border-radius: 50%; width: 12px; height: 12px; /* transform: translateX(100%); */ }
      &.have_notes {
        &::before { background: #52DDC3; }
      }
      
      .title-content { display: flex; align-items: center; gap: 8px; width: 100%; position: relative;
        &.editable {
          .edit-icon-btn { 
            opacity: 0; 
            visibility: hidden; 
            transition: opacity 0.2s ease, visibility 0.2s ease; 
            background: none; 
            border: none; 
            cursor: pointer; 
            padding: 4px;
            margin-left: 8px;
            
            i { 
              font-size: 14px; 
              color: #666; 
            }
          }
          
          &:hover .edit-icon-btn { 
            opacity: 1; 
            visibility: visible; 
            
            i { 
              color: #333; 
            }
          }
        }
      }
      
      .title-edit { display: flex; flex-direction: column; gap: 8px; width: 100%;
        .title-textarea { width: 100%; resize: vertical; min-height: 40px; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-family: inherit; font-size: inherit; font-weight: inherit; }
        
        .save-btn, .cancel-btn { padding: 4px 12px; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; }
        .save-btn { background: #52DDC3; color: white; 
          &:hover { background: #45c4a8; }
        }
        .cancel-btn { background: #ccc; color: #333; margin-left: 4px;
          &:hover { background: #bbb; }
        }
      }
    }
    
    .clause-content { font-weight: 400; font-size: 14px; padding: 10px 0px 10px 10px; border-radius: 4px; white-space: pre-wrap; word-break: break-word; word-wrap: break-word; overflow-wrap: break-word; text-align: right; font-size: var(--h5); }
  }
  .clauses-container { display: flex; flex-direction: column; gap: var(--gap_xmid);
    .flex-row { display: flex; min-width: max-content;display: flex; gap: var(--gap); 
      .flex-cell { position: relative; font-size: var(--h5); border: 0.5px solid #D9D9D9;transition: width 0.3s ease; width: var(--clause_width); border-radius: 15px; text-align: center; 
        &, * { cursor: pointer !important; }
        &.selected {  border: 1px solid #52DDC3; background: var(--gray); 
          .add_note {  border: 1px solid #52DDC3; background: #FFF; 
            svg, i { color: #000; }
          }
        }
        .answer_container { display: flex; flex-direction: column; align-items: center; gap: var(--gap_small); padding-block: var(--gap_xmid) var(--gap); }
        .add_note { z-index: 1;  position: absolute; bottom: 0; right: 50%; transform: translate(50%, 50%); border-radius: 50%; width: 20px; height: 20px; background: #D9D9D9;
          &, * { cursor: pointer !important; }
          svg, i {     color: #fff; pointer-events: none; text-align: center; align-content: center; font-size: 12px; }
          .add { transform: translateY(-6px); }
          .times { transform: translate(-0px, -7px); 
            svg, i { color: var(--dark_blue); }
          }
        }
        .answer_status { border-radius: 50%; width: 30px; height: 30px; position: relative;
          &.accepted { background: #8EDA93; }
          &.rejected { background: #DA8E8E; }
          &.pending { background: #F0E172;
            svg { padding-bottom: 12px; font-size: 18px;}
          }
          svg, i { color: var(--dark_blue); text-align: center; align-content: center; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
        }
        svg, i { cursor: pointer;}
      }
      .answer_text { font-size: var(--h5); min-height: calc(var(--gap_xmid) - var(--gap)); }
    }
    .notes_container { display: flex; flex-direction: column; gap: var(--gap_xmid); }
  }
}



</style> 
